import { getPermissionsForCoreUploadTypes } from '@repo/csv'
import { createFileRoute } from '@tanstack/react-router'
import { ON_HAND_INVENTORY_UPLOAD_TYPES } from './-upload-types'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data/on-hand-inventory')({
  staticData: {
    title: 'route.coreUploadData.onHandInventory',
    crumb: 'route.coreUploadData.onHandInventory',
    permissions: getPermissionsForCoreUploadTypes(ON_HAND_INVENTORY_UPLOAD_TYPES),
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route, { atLeastOne: true })
  },
})
